// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.records-page {
  position: relative;
}

.records-service-closures summary {
  cursor: pointer;
}
.records-service-closures form {
  display: grid;
  gap: 12px;
}
.records-service-closures label {
  display: grid;
  gap: 6px;
}
.records-service-closures textarea {
  min-height: 90px;
}
.records-service-closures > div {
  border-top: 1px solid #e1e6f0;
  margin-top: 14px;
  padding-top: 14px;
}

.records-booking-diagnostics {
  background: #fff8e8;
  border: 1px solid #e8ca83;
}
.records-booking-diagnostics p {
  margin: 10px 0;
}
.records-booking-diagnostics summary {
  cursor: pointer;
}
.records-booking-diagnostics ul {
  margin: 10px 0;
  padding-left: 20px;
}

.records-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.records-assignment-filter {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.records-filter-button {
  min-height: 42px;
  border: 1px solid #e1e6f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #546179;
  font-weight: 700;
  cursor: pointer;
}

.records-filter-button.active {
  border-color: #232137;
  background: #232137;
  color: #fff;
}

.records-pool-settings {
  display: grid;
  gap: 12px;
}

.records-master-permissions-body {
  display: grid;
  gap: 12px;
  padding-top: 14px;
  margin-top: 12px;
  border-top: 1px solid #edf0f5;
}

.records-master-permissions-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.records-master-permissions-refresh {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 8px 14px;
}

.records-master-permissions-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.records-master-permission-card {
  display: grid;
  gap: 10px;
  padding: 14px;
  border: 1px solid #e1e6f0;
  border-radius: 16px;
  background: #fbfcfe;
}

.records-master-permission-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #232137;
  font-size: 0.98rem;
  font-weight: 800;
}

.records-master-permission-name span {
  color: #7d8ca6;
  font-size: 0.76rem;
  font-weight: 700;
}

.records-master-permission-reason {
  padding: 8px 10px;
  border-radius: 10px;
  background: #eef3f8;
  color: #637189;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.35;
}

.records-master-permission-reason.conflict {
  background: #fff2f3;
  color: #b51d31;
}

.records-master-permission-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #fff;
  color: #232137;
  cursor: pointer;
}

.records-master-permission-toggle input {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin-top: 1px;
  accent-color: #e72f44;
}

.records-master-permission-toggle input:disabled {
  cursor: wait;
  opacity: 0.6;
}

.records-master-permission-toggle span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.records-master-permission-toggle strong {
  font-size: 0.9rem;
  line-height: 1.25;
}

.records-master-permission-toggle small {
  color: #7d8ca6;
  font-size: 0.8rem;
  line-height: 1.3;
}

.records-master-permissions-empty {
  margin: 0;
}

.records-pool-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #232137;
  font-weight: 800;
}

.records-pool-toggle input {
  width: 20px;
  height: 20px;
  accent-color: #e72f44;
}

.records-create-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  margin-top: 12px;
  border-radius: 14px;
  background: #232137;
  color: #fff;
  font-size: 0.98rem;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 9px 18px rgba(35, 33, 55, 0.16);
}

.records-tab {
  border: 1px solid #e1e6f0;
  border-radius: 14px;
  padding: 12px 10px;
  font-size: 0.96rem;
  font-weight: 700;
  background: #f8fafc;
  color: #546179;
  cursor: pointer;
  transition: all 0.15s ease;
}

.records-tab.active {
  background: #e72f44;
  border-color: #e72f44;
  color: #fff;
  box-shadow: 0 8px 18px rgba(231, 47, 68, 0.22);
}

.records-record-button {
  cursor: pointer;
}

.records-record-button:hover {
  transform: translateY(-1px);
}

.records-amount {
  font-size: 0.96rem;
  font-weight: 800;
  color: #232137;
  white-space: nowrap;
}

.records-flags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.records-calendar {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.records-day {
  border: 1px solid #e3e8f2;
  border-radius: 16px;
  background: #fbfcfe;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.records-day.has-records {
  border-color: #f6b5bc;
  background: #fff7f8;
}

.records-day.active {
  background: #232137;
  border-color: #232137;
  color: #fff;
  box-shadow: 0 10px 22px rgba(35, 33, 55, 0.18);
}

.records-day-label {
  font-size: 0.94rem;
  font-weight: 700;
}

.records-day-count {
  font-size: 0.84rem;
  color: inherit;
  opacity: 0.82;
}

.records-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(24, 27, 39, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 12px;
  z-index: 1000;
}

.records-modal {
  width: min(100%, 480px);
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  border-radius: 24px 24px 18px 18px;
  background: #f7f9fa;
  box-shadow: 0 16px 42px rgba(15, 21, 38, 0.26);
  padding: 18px 14px 20px;
}

.records-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.records-close {
  border: none;
  background: #fff;
  color: #232137;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  font-size: 1.45rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 3px 14px rgba(36, 41, 57, 0.08);
}

.records-close:disabled {
  cursor: wait;
  opacity: 0.55;
}

.records-delete-button {
  border-color: #efb9c1;
  color: #b51d31;
}

.lkfr-app .records-page .records-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.lkfr-app .records-page .records-heading .section-title {
  margin: 0;
}
.lkfr-app .records-page .records-schedule-link {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 10px 14px;
  font-size: 13px;
}
.lkfr-app .records-page .records-search {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
  color: var(--lkfr-muted);
  font-size: 12px;
}
.lkfr-app .records-page .records-search input {
  width: 100%;
  min-height: 44px;
}
.lkfr-app .records-page .records-context-card {
  padding: 14px;
  margin-bottom: 12px;
}
.lkfr-app .records-page .records-context-card .section-subtitle {
  margin-bottom: 4px;
  font-size: 18px;
}
.lkfr-app .records-page .records-context-card .section-helper {
  margin: 0;
  font-size: 13px;
}
.lkfr-app .records-page .records-tabs {
  margin-top: 12px;
}
.lkfr-app .records-page .records-tab {
  min-height: 44px;
  padding: 9px 10px;
  border-radius: 12px;
  box-shadow: none;
}
.lkfr-app .records-page .records-create-link {
  min-height: 44px;
  margin-top: 8px;
  border-radius: 12px;
  box-shadow: none;
}
.lkfr-app .records-page .records-assignment-filter {
  padding: 5px;
  gap: 5px;
  margin-bottom: 12px;
  border-radius: 14px;
}
.lkfr-app .records-page .records-filter-button {
  min-height: 44px;
  padding: 6px;
  font-size: 13px;
}
.lkfr-app .records-page .records-master-permissions {
  display: block;
  padding: 12px 14px;
  margin-top: 16px;
}
.lkfr-app .records-page .records-permissions-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 44px;
  cursor: pointer;
  list-style: none;
}
.lkfr-app .records-page .records-permissions-summary::-webkit-details-marker {
  display: none;
}
.lkfr-app .records-page .records-permissions-summary::marker {
  content: "";
}
.lkfr-app .records-page .records-permissions-summary:focus-visible {
  outline: 3px solid #6177e7;
  outline-offset: 4px;
  border-radius: 6px;
}
.lkfr-app .records-page .records-permissions-summary > span {
  display: grid;
  gap: 3px;
  min-width: 0;
}
.lkfr-app .records-page .records-permissions-summary strong {
  font-size: 16px;
}
.lkfr-app .records-page .records-permissions-summary small {
  color: var(--lkfr-muted);
  font-size: 12px;
}
.lkfr-app .records-page .records-permissions-summary svg {
  flex: 0 0 auto;
  color: var(--lkfr-muted);
  transition: transform 0.15s ease;
}
.lkfr-app .records-page .records-master-permissions[open] > summary svg {
  transform: rotate(180deg);
}
.lkfr-app .records-page .records-master-permissions-head .section-helper {
  margin: 0;
  font-size: 13px;
}
.lkfr-app .records-page .records-master-permissions-refresh {
  min-height: 44px;
}

@media (max-width: 680px) {
  .records-master-permissions-head {
    align-items: stretch;
    flex-direction: column;
  }
  .records-master-permissions-refresh {
    width: 100%;
  }
  .records-master-permissions-list {
    grid-template-columns: minmax(0, 1fr);
  }
}
.record-create-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.record-create-title-row .section-title {
  margin-right: auto;
}

.record-create-back {
  flex: 0 0 auto;
  padding: 10px 12px;
}

.record-create-hint {
  background: #232137;
  color: #fff;
}

.record-create-hint .section-subtitle,
.record-create-hint .section-item-text {
  color: #fff;
}

.record-create-note {
  border-radius: 12px;
  background: #f6f8fb;
  color: #546179;
  font-size: 0.9rem;
  line-height: 1.45;
  padding: 10px 12px;
}

.record-create-services-group + .record-create-services-group {
  margin-top: 16px;
}

.record-create-group-title {
  margin-bottom: 10px;
  color: #232137;
  font-size: 1rem;
  font-weight: 800;
}

.record-create-services-list {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.record-create-service {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e1e6f0;
  border-radius: 14px;
  background: #fbfcfe;
  padding: 12px 13px;
  text-align: left;
  cursor: pointer;
}

.record-create-service.active {
  border-color: #e72f44;
  background: #fff5f6;
}

.record-create-service.disabled,
.record-create-service:disabled {
  opacity: 0.48;
  cursor: not-allowed;
}

.record-create-service-main {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.record-create-service-title {
  color: #232137;
  font-size: 0.96rem;
  font-weight: 800;
}

.record-create-service-meta,
.record-create-service-reason {
  font-size: 0.86rem;
  line-height: 1.35;
}

.record-create-service-meta {
  color: #7d8ca6;
}

.record-create-service-reason {
  color: #b51d31;
}

.record-create-service-state {
  flex: 0 0 auto;
  color: #232137;
  font-size: 0.82rem;
  font-weight: 800;
  white-space: nowrap;
}

.record-create-empty-inner {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
}

.record-create-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #232137;
  font-size: 0.96rem;
}

.record-create-selected-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-create-selected-service {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 12px;
  background: #f6f8fb;
  padding: 10px 11px;
  color: #232137;
  font-size: 0.92rem;
}

.record-create-selected-service button {
  border: none;
  background: transparent;
  color: #c61f35;
  font-weight: 800;
  cursor: pointer;
}

.record-create-retry {
  margin-top: 12px;
}

.record-create-submit-error {
  line-height: 1.45;
  white-space: pre-line;
}

.record-create-submit {
  position: sticky;
  bottom: 12px;
  z-index: 5;
  width: 100%;
  min-height: 50px;
  margin: 0 0 74px;
  box-shadow: 0 12px 24px rgba(231, 47, 68, 0.22);
}

@media (max-width: 420px) {
  .records-calendar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .record-create-title-row {
    align-items: flex-start;
  }
  .record-create-service {
    flex-direction: column;
    gap: 8px;
  }
  .record-create-service-state {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/RecordsPage/RecordsPage.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAGE;EAAU,eAAA;AACZ;AAAE;EAAO,aAAA;EAAe,SAAA;AAIxB;AAHE;EAAQ,aAAA;EAAe,QAAA;AAOzB;AANE;EAAW,gBAAA;AASb;AARE;EAAQ,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;AAa3D;;AAVA;EACE,mBAAA;EACA,yBAAA;AAaF;AAXE;EAAI,cAAA;AAcN;AAbE;EAAU,eAAA;AAgBZ;AAfE;EAAK,cAAA;EAAgB,kBAAA;AAmBvB;;AAhBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAmBF;;AAhBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,SAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,mBAAA;EACA,cAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AAmBF;;AAhBA;EACE,iBAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,SAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,6CAAA;AAmBF;;AAhBA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAmBF;;AAhBA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,8CAAA;AAmBF;;AAhBA;EACE,eAAA;AAmBF;;AAhBA;EACE,2BAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAmBF;;AAhBA;EACE,qBAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,8CAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,QAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAmBF;;AAhBA;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,8CAAA;EACA,uBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,6CAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,aAAA;AAmBF;;AAhBA;EACE,qBAAA;EACA,cAAA;AAmBF;;AAfE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAkBJ;AAhBI;EAAiB,SAAA;AAmBrB;AAhBE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAkBJ;AAfE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;AAiBJ;AAfI;EAAQ,WAAA;EAAa,gBAAA;AAmBzB;AAhBE;EAAwB,aAAA;EAAe,mBAAA;AAoBzC;AAnBE;EAA0C,kBAAA;EAAoB,eAAA;AAuBhE;AAtBE;EAAwC,SAAA;EAAW,eAAA;AA0BrD;AAzBE;EAAgB,gBAAA;AA4BlB;AA3BE;EAAe,gBAAA;EAAkB,iBAAA;EAAmB,mBAAA;EAAqB,gBAAA;AAiC3E;AAhCE;EAAuB,gBAAA;EAAkB,eAAA;EAAiB,mBAAA;EAAqB,gBAAA;AAsCjF;AArCE;EAA6B,YAAA;EAAc,QAAA;EAAU,mBAAA;EAAqB,mBAAA;AA2C5E;AA1CE;EAAyB,gBAAA;EAAkB,YAAA;EAAc,eAAA;AA+C3D;AA9CE;EAA8B,cAAA;EAAgB,kBAAA;EAAoB,gBAAA;AAmDpE;AAjDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAmDJ;AAjDI;EAA4B,aAAA;AAoDhC;AAnDI;EAAY,WAAA;AAsDhB;AArDI;EAAkB,0BAAA;EAA4B,mBAAA;EAAqB,kBAAA;AA0DvE;AAzDI;EAAS,aAAA;EAAe,QAAA;EAAU,YAAA;AA8DtC;AA7DI;EAAS,eAAA;AAgEb;AA/DI;EAAQ,wBAAA;EAA0B,eAAA;AAmEtC;AAlEI;EAAM,cAAA;EAAgB,wBAAA;EAA0B,gCAAA;AAuEpD;AApEE;EAAkD,yBAAA;AAuEpD;AAtEE;EAAmD,SAAA;EAAW,eAAA;AA0EhE;AAzEE;EAAsC,gBAAA;AA4ExC;;AAzEA;EACE;IACE,oBAAA;IACA,sBAAA;EA4EF;EAzEA;IACE,WAAA;EA2EF;EAxEA;IACE,qCAAA;EA0EF;AACF;AAvEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAyEF;;AAtEA;EACE,kBAAA;AAyEF;;AAtEA;EACE,cAAA;EACA,kBAAA;AAyEF;;AAtEA;EACE,mBAAA;EACA,WAAA;AAyEF;;AAtEA;;EAEE,WAAA;AAyEF;;AAtEA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAyEF;;AAtEA;EACE,gBAAA;AAyEF;;AAtEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAyEF;;AAtEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAyEF;;AAtEA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAyEF;;AAtEA;EACE,qBAAA;EACA,mBAAA;AAyEF;;AAtEA;;EAEE,aAAA;EACA,mBAAA;AAyEF;;AAtEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AAyEF;;AAtEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAyEF;;AAtEA;;EAEE,kBAAA;EACA,iBAAA;AAyEF;;AAtEA;EACE,cAAA;AAyEF;;AAtEA;EACE,cAAA;AAyEF;;AAtEA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAyEF;;AAtEA;EACE,gBAAA;EACA,UAAA;EACA,uBAAA;AAyEF;;AAtEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAyEF;;AAtEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAyEF;;AAtEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAyEF;;AAtEA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAyEF;;AAtEA;EACE,gBAAA;AAyEF;;AAtEA;EACE,iBAAA;EACA,qBAAA;AAyEF;;AAtEA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,+CAAA;AAyEF;;AAtEA;EACE;IACE,gDAAA;EAyEF;EAtEA;IACE,uBAAA;EAwEF;EArEA;IACE,sBAAA;IACA,QAAA;EAuEF;EApEA;IACE,mBAAA;EAsEF;AACF","sourcesContent":[".records-page {\n  position: relative;\n}\n\n.records-service-closures {\n  summary { cursor: pointer; }\n  form { display: grid; gap: 12px; }\n  label { display: grid; gap: 6px; }\n  textarea { min-height: 90px; }\n  > div { border-top: 1px solid #e1e6f0; margin-top: 14px; padding-top: 14px; }\n}\n\n.records-booking-diagnostics {\n  background: #fff8e8;\n  border: 1px solid #e8ca83;\n\n  p { margin: 10px 0; }\n  summary { cursor: pointer; }\n  ul { margin: 10px 0; padding-left: 20px; }\n}\n\n.records-tabs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.records-assignment-filter {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.records-filter-button {\n  min-height: 42px;\n  border: 1px solid #e1e6f0;\n  border-radius: 12px;\n  background: #f8fafc;\n  color: #546179;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.records-filter-button.active {\n  border-color: #232137;\n  background: #232137;\n  color: #fff;\n}\n\n.records-pool-settings {\n  display: grid;\n  gap: 12px;\n}\n\n.records-master-permissions-body {\n  display: grid;\n  gap: 12px;\n  padding-top: 14px;\n  margin-top: 12px;\n  border-top: 1px solid #edf0f5;\n}\n\n.records-master-permissions-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.records-master-permissions-refresh {\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 8px 14px;\n}\n\n.records-master-permissions-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.records-master-permission-card {\n  display: grid;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid #e1e6f0;\n  border-radius: 16px;\n  background: #fbfcfe;\n}\n\n.records-master-permission-name {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  color: #232137;\n  font-size: 0.98rem;\n  font-weight: 800;\n}\n\n.records-master-permission-name span {\n  color: #7d8ca6;\n  font-size: 0.76rem;\n  font-weight: 700;\n}\n\n.records-master-permission-reason {\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #eef3f8;\n  color: #637189;\n  font-size: 0.8rem;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.records-master-permission-reason.conflict {\n  background: #fff2f3;\n  color: #b51d31;\n}\n\n.records-master-permission-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid #edf0f5;\n  border-radius: 12px;\n  background: #fff;\n  color: #232137;\n  cursor: pointer;\n}\n\n.records-master-permission-toggle input {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  accent-color: #e72f44;\n}\n\n.records-master-permission-toggle input:disabled {\n  cursor: wait;\n  opacity: 0.6;\n}\n\n.records-master-permission-toggle span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.records-master-permission-toggle strong {\n  font-size: 0.9rem;\n  line-height: 1.25;\n}\n\n.records-master-permission-toggle small {\n  color: #7d8ca6;\n  font-size: 0.8rem;\n  line-height: 1.3;\n}\n\n.records-master-permissions-empty {\n  margin: 0;\n}\n\n.records-pool-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #232137;\n  font-weight: 800;\n}\n\n.records-pool-toggle input {\n  width: 20px;\n  height: 20px;\n  accent-color: #e72f44;\n}\n\n.records-create-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 46px;\n  margin-top: 12px;\n  border-radius: 14px;\n  background: #232137;\n  color: #fff;\n  font-size: 0.98rem;\n  font-weight: 800;\n  text-decoration: none;\n  box-shadow: 0 9px 18px rgba(35, 33, 55, 0.16);\n}\n\n.records-tab {\n  border: 1px solid #e1e6f0;\n  border-radius: 14px;\n  padding: 12px 10px;\n  font-size: 0.96rem;\n  font-weight: 700;\n  background: #f8fafc;\n  color: #546179;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.records-tab.active {\n  background: #e72f44;\n  border-color: #e72f44;\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(231, 47, 68, 0.22);\n}\n\n.records-record-button {\n  cursor: pointer;\n}\n\n.records-record-button:hover {\n  transform: translateY(-1px);\n}\n\n.records-amount {\n  font-size: 0.96rem;\n  font-weight: 800;\n  color: #232137;\n  white-space: nowrap;\n}\n\n.records-flags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.records-calendar {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.records-day {\n  border: 1px solid #e3e8f2;\n  border-radius: 16px;\n  background: #fbfcfe;\n  padding: 12px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.records-day.has-records {\n  border-color: #f6b5bc;\n  background: #fff7f8;\n}\n\n.records-day.active {\n  background: #232137;\n  border-color: #232137;\n  color: #fff;\n  box-shadow: 0 10px 22px rgba(35, 33, 55, 0.18);\n}\n\n.records-day-label {\n  font-size: 0.94rem;\n  font-weight: 700;\n}\n\n.records-day-count {\n  font-size: 0.84rem;\n  color: inherit;\n  opacity: 0.82;\n}\n\n.records-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(24, 27, 39, 0.5);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 12px;\n  z-index: 1000;\n}\n\n.records-modal {\n  width: min(100%, 480px);\n  max-height: calc(100vh - 24px);\n  overflow-y: auto;\n  border-radius: 24px 24px 18px 18px;\n  background: #f7f9fa;\n  box-shadow: 0 16px 42px rgba(15, 21, 38, 0.26);\n  padding: 18px 14px 20px;\n}\n\n.records-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.records-close {\n  border: none;\n  background: #fff;\n  color: #232137;\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  font-size: 1.45rem;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 3px 14px rgba(36, 41, 57, 0.08);\n}\n\n.records-close:disabled {\n  cursor: wait;\n  opacity: 0.55;\n}\n\n.records-delete-button {\n  border-color: #efb9c1;\n  color: #b51d31;\n}\n\n.lkfr-app .records-page {\n  .records-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n\n    .section-title { margin: 0; }\n  }\n\n  .records-schedule-link {\n    flex: 0 0 auto;\n    min-height: 44px;\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .records-search {\n    display: grid;\n    gap: 6px;\n    margin-bottom: 12px;\n    color: var(--lkfr-muted);\n    font-size: 12px;\n\n    input { width: 100%; min-height: 44px; }\n  }\n\n  .records-context-card { padding: 14px; margin-bottom: 12px; }\n  .records-context-card .section-subtitle { margin-bottom: 4px; font-size: 18px; }\n  .records-context-card .section-helper { margin: 0; font-size: 13px; }\n  .records-tabs { margin-top: 12px; }\n  .records-tab { min-height: 44px; padding: 9px 10px; border-radius: 12px; box-shadow: none; }\n  .records-create-link { min-height: 44px; margin-top: 8px; border-radius: 12px; box-shadow: none; }\n  .records-assignment-filter { padding: 5px; gap: 5px; margin-bottom: 12px; border-radius: 14px; }\n  .records-filter-button { min-height: 44px; padding: 6px; font-size: 13px; }\n  .records-master-permissions { display: block; padding: 12px 14px; margin-top: 16px; }\n\n  .records-permissions-summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    min-height: 44px;\n    cursor: pointer;\n    list-style: none;\n\n    &::-webkit-details-marker { display: none; }\n    &::marker { content: \"\"; }\n    &:focus-visible { outline: 3px solid #6177e7; outline-offset: 4px; border-radius: 6px; }\n    > span { display: grid; gap: 3px; min-width: 0; }\n    strong { font-size: 16px; }\n    small { color: var(--lkfr-muted); font-size: 12px; }\n    svg { flex: 0 0 auto; color: var(--lkfr-muted); transition: transform .15s ease; }\n  }\n\n  .records-master-permissions[open] > summary svg { transform: rotate(180deg); }\n  .records-master-permissions-head .section-helper { margin: 0; font-size: 13px; }\n  .records-master-permissions-refresh { min-height: 44px; }\n}\n\n@media (max-width: 680px) {\n  .records-master-permissions-head {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .records-master-permissions-refresh {\n    width: 100%;\n  }\n\n  .records-master-permissions-list {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.record-create-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.record-create-title-row .section-title {\n  margin-right: auto;\n}\n\n.record-create-back {\n  flex: 0 0 auto;\n  padding: 10px 12px;\n}\n\n.record-create-hint {\n  background: #232137;\n  color: #fff;\n}\n\n.record-create-hint .section-subtitle,\n.record-create-hint .section-item-text {\n  color: #fff;\n}\n\n.record-create-note {\n  border-radius: 12px;\n  background: #f6f8fb;\n  color: #546179;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  padding: 10px 12px;\n}\n\n.record-create-services-group + .record-create-services-group {\n  margin-top: 16px;\n}\n\n.record-create-group-title {\n  margin-bottom: 10px;\n  color: #232137;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.record-create-services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.record-create-service {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid #e1e6f0;\n  border-radius: 14px;\n  background: #fbfcfe;\n  padding: 12px 13px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.record-create-service.active {\n  border-color: #e72f44;\n  background: #fff5f6;\n}\n\n.record-create-service.disabled,\n.record-create-service:disabled {\n  opacity: 0.48;\n  cursor: not-allowed;\n}\n\n.record-create-service-main {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.record-create-service-title {\n  color: #232137;\n  font-size: 0.96rem;\n  font-weight: 800;\n}\n\n.record-create-service-meta,\n.record-create-service-reason {\n  font-size: 0.86rem;\n  line-height: 1.35;\n}\n\n.record-create-service-meta {\n  color: #7d8ca6;\n}\n\n.record-create-service-reason {\n  color: #b51d31;\n}\n\n.record-create-service-state {\n  flex: 0 0 auto;\n  color: #232137;\n  font-size: 0.82rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.record-create-empty-inner {\n  margin-bottom: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.record-create-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n  color: #232137;\n  font-size: 0.96rem;\n}\n\n.record-create-selected-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.record-create-selected-service {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-radius: 12px;\n  background: #f6f8fb;\n  padding: 10px 11px;\n  color: #232137;\n  font-size: 0.92rem;\n}\n\n.record-create-selected-service button {\n  border: none;\n  background: transparent;\n  color: #c61f35;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.record-create-retry {\n  margin-top: 12px;\n}\n\n.record-create-submit-error {\n  line-height: 1.45;\n  white-space: pre-line;\n}\n\n.record-create-submit {\n  position: sticky;\n  bottom: 12px;\n  z-index: 5;\n  width: 100%;\n  min-height: 50px;\n  margin: 0 0 74px;\n  box-shadow: 0 12px 24px rgba(231, 47, 68, 0.22);\n}\n\n@media (max-width: 420px) {\n  .records-calendar {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .record-create-title-row {\n    align-items: flex-start;\n  }\n\n  .record-create-service {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .record-create-service-state {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
